import React, { useState } from 'react';
import './ContactPage.css';
import contactImg from '../../assets/images/pic-6.webp';
import picHero from '../../assets/images/pic-1.webp';
import { ContactService } from '../../services/api.services';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');
    
    if (!formData.name.trim() || !formData.email.trim()) {
      setErrorMsg('Please fill in all required fields.');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setErrorMsg('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    const res = await ContactService.submit(formData);
    setLoading(false);
    
    if (res.success) {
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
    } else {
      setErrorMsg(res.message);
    }
  };

  return (
    <main className="contact-page">
      {/* ── 1. HERO ── */}
      <section
        className="ct-hero"
        style={{ backgroundImage: `url("${picHero}")` }}
      >
        <div className="ct-hero-overlay" />
        <div className="ct-hero-content">
          <p className="ct-hero-label">GET IN TOUCH</p>
          <h1 className="ct-hero-heading">
            I'm always happy to hear from<br />
            fellow food lovers and friends.
          </h1>
          <p className="ct-hero-signature">Loganayaki Thamilselvan</p>
        </div>
      </section>

      {/* ── 2. TWO-COLUMN LAYOUT ── */}
      <div className="contact-layout">

        {/* LEFT — Photo Panel */}
        <div className="contact-photo-panel">
          <img src={contactImg} alt="Contact Me" className="contact-photo" />
          <div className="contact-photo-overlay" />
          <h2 className="contact-photo-title">Contact Me</h2>
        </div>

        {/* RIGHT — Info + Form */}
        <div className="contact-content-panel">

          {/* Intro paragraph */}
          <p className="contact-intro">
            <span className="contact-drop-cap">L</span>
            orem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet
            cursus sit amet dictum sit amet. Pellentesque habitant morbi
            tristique senectus et netus et malesuada. Eu sem integer vitae justo
            eget magna fermentum iaculis eu.
          </p>

          <ul className="contact-info-list">
            <li>
              For all business inquires, please contact{' '}
              <a href="mailto:famousindianrecipes@gmail.com">famousindianrecipes@gmail.com</a>
            </li>
            <li>
              Need shopping help or have shop-related questions? Please send
              questions to{' '}
              <a href="mailto:help@famousindianrecipes.com">help@famousindianrecipes.com</a>
            </li>
            <li>
              General recipe questions? Please send your question via the form
              below.
            </li>
          </ul>

          {/* Form header */}
          <h3 className="contact-form-heading">
            Any questions about recipes? Fill the form:
          </h3>

          {submitted ? (
            <div className="contact-success">
              ✓ Thank you for your message! We'll get back to you soon.
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              {errorMsg && (
                <div style={{ color: '#d9534f', backgroundColor: '#fdf7f7', padding: '10px 15px', borderRadius: '4px', marginBottom: '20px', border: '1px solid #ebccd1' }}>
                  {errorMsg}
                </div>
              )}
              
              <div className="contact-field">
                <label htmlFor="contact-name">Your Name (required)</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-field">
                <label htmlFor="contact-email">Your Email (required)</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-field">
                <label htmlFor="contact-subject">Subject</label>
                <input
                  id="contact-subject"
                  name="subject"
                  type="text"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="contact-field">
                <label htmlFor="contact-message">Your Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="contact-send-btn" disabled={loading}>
                {loading ? 'SENDING...' : 'SEND'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* ── 3. ADDRESS & SOCIAL SECTION ── */}
      {/* <section className="ct-details-section">
        <div className="ct-details-inner">
          <div className="ct-detail-card">
            <div className="ct-detail-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
            </div>
            <h3>Our Office</h3>
            <p>123 Kitchen Avenue, Spice District<br />New Delhi, India 110001</p>
          </div>

          <div className="ct-detail-card">
            <div className="ct-detail-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
            </div>
            <h3>Call Us</h3>
            <p>Main Office: +91 123 456 7890<br />Support: +91 987 654 3210</p>
          </div>

          <div className="ct-detail-card">
            <div className="ct-detail-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
            </div>
            <h3>Email Directly</h3>
            <p>hello@famousindianrecipes.com<br />careers@famousindianrecipes.com</p>
          </div>
        </div>
      </section> */}
    </main>
  );
};

export default ContactPage;
